import Lottie from 'lottie-react';
import catTailAnimation from 'lottie/cat-tail.json';
import { LayoutContainer } from 'layout';
import {
    Button,
    ButtonSize,
    Checkbox,
    CheckboxColorsForRevelantSection,
    CheckboxSize,
    InvertedBackground,
    SectionContainer
} from 'ui';

import {
    checkboxWrapper,
    contentContainer,
    animationWrapper,
    layoutContainerOverride,
    sectionContainer
} from './you-read-new-section.module.scss';
import { colorBgInvertedPrimaryTwo } from 'ui/invertedBackground/inverted-background.module.scss';

const checkboxes = [
    'Collect it on your context card.',
    'Connect it to your knowledge.',
    'Move the PDF or source to the \nbackground, where it belongs.'
];

export const YouReadNewSection = () => {
    return (
        <InvertedBackground color={colorBgInvertedPrimaryTwo}>
            <LayoutContainer className={layoutContainerOverride}>
                <SectionContainer className={sectionContainer}>
                    <div className={animationWrapper}>
                        <Lottie animationData={catTailAnimation} loop={true} />
                    </div>
                    <div className={contentContainer}>
                        <h3>You read new and relevant information?</h3>
                        <div className={checkboxWrapper}>
                            {checkboxes.map((text, index) => (
                                <Checkbox
                                    key={text}
                                    color={
                                        CheckboxColorsForRevelantSection[
                                            index % CheckboxColorsForRevelantSection.length
                                        ]
                                    }
                                    size={CheckboxSize.Large}
                                    text={text}
                                />
                            ))}
                        </div>
                        <a href={process.env.GATSBY_ELUMITY_APP_URL + '/signup'}>
                            <Button text="Get started" size={ButtonSize.Medium} />
                        </a>
                    </div>
                </SectionContainer>
            </LayoutContainer>
        </InvertedBackground>
    );
};
